// 测试环境
const $url = process.env.NODE_ENV === 'production' ? '' : ''

export default $url
